import { createSlice } from '@reduxjs/toolkit';
export const initialState = {
  list: [],
  isLoad: false
};
// Create GetEPVolunteerRegFilterSlice with name and initial state
const GetEPVolunteerRegFilterSlice = createSlice({
  name: 'epVolunteerReg',
  initialState,
  reducers: {
    // Create action with name and payload
    setEPVolunteerReg: (state, action) => {
      state.list = action.payload;
    },
    setIsLoadVolunteerReg: (state, action) => {
      state.isLoad = action.payload;
    }
  }
});

// Export action to use in component
export const { setEPVolunteerReg,setIsLoadVolunteerReg } = GetEPVolunteerRegFilterSlice.actions;

// Export the reducer for the slice
export default GetEPVolunteerRegFilterSlice.reducer;
